/** Fetch the actual production PDF without rasterizing its preview or replacing technical separations. */
export async function originalProductionPdf(url: string, fetcher: typeof fetch = fetch): Promise<Blob> {
  const response = await fetcher(url, { signal: AbortSignal.timeout(15000) });
  if (!response.ok) throw new Error('Het originele drukbestand kon niet worden geladen');
  const blob = await response.blob();
  const signature = new Uint8Array(await blob.slice(0, 5).arrayBuffer());
  if (String.fromCharCode(...signature) !== '%PDF-') throw new Error('Het originele bestand is geen geldig PDF-bestand');
  return blob;
}
